import { Component, Input } from '@angular/core';
import { environment } from '@env/environment';
import { BlogAuthor } from '@shared/models/blog-author.model';
import { BlogCategory } from '@shared/models/blog-category.model';

@Component({
    selector: 'gh-pagination',
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.scss'],
    standalone: false
})
export class PaginationComponent {
  @Input() pager: any;
  @Input() type: 'home' | 'category' | 'author';
  @Input() entity: BlogCategory | BlogAuthor | undefined;
  @Input() currentPage: number;

  // Home pagination props
  @Input() pageIndex = 0;
  @Input() pagePreviewSize = 5;
  @Input() pagePreviewList: number[] | undefined;

  readonly rootPath = environment.root;

  get paginationPreview(): number[] {
    const trimmedList = this.pager.totalPages < 6 // return the default list if less than 6 pages
      ? this.pager.indexes
      : this.currentPage >= this.pager.totalPages - 2 // return last five pages in list if within last 3 pages
        ? this.pager.indexes.slice(this.pager.totalPages - 5, this.pager.totalPages)
        : this.currentPage > 3
          ? this.pager.indexes.slice(this.currentPage - 3, this.currentPage + 2) // return two previos, current, and two next pages if current page is above 3
          : this.pager.indexes.slice(0, 5); // return first five pages if within first 3 pages

    return trimmedList; // return default pager indexes
  }

  get lastArticleNumber(): number {
    return this.pager.totalElements;
  }

  get basePath(): string {
    return this.type === 'author'
      ? `./author/${this.entity.slug}` // return base author path if pagination type === 'author'
      : this.type === 'category'
        ? `./${this.entity.slug}` // return base category path if pagination type === 'category'
        : this.rootPath; // return root path if home
  }

  get beginningLink(): string {
    if (this.pager.isFirst) {
      return ``;
    }

    return this.basePath;
  }

  get endLink(): string {
    if (this.pager.isLast) {
      return ``;
    }

    return `${this.basePath}/page/${this.pager.totalPages}`;
  }

  get prevLink(): string {
    if (this.pager.isFirst) {
      return ``;
    }

    if (this.pager.pageNumber !== 1) {
      return `${this.basePath}/page/${this.currentPage - 1}`;
    }

    return this.basePath;
  }

  get nextLink(): string {
    if (this.pager.isLast) {
      return ``;
    }

    return `${this.basePath}/page/${this.currentPage + 1}`;
  }

  getNumberLink(i: number): string {
    if (this.paginationPreview[i] == 1) {
      return this.basePath;
    }

    return `${this.basePath}/page/${this.paginationPreview[i]}`;
  }

}
